import { AllLeaguesSchema } from '@/views/sports/AllLeagues/styles/AllLeagues.styles';

export const allLeaguesStyles: AllLeaguesSchema = {
  headerSportText: {
    fontSize: 'sm',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
    color: 'white',
    fontFamily: 'Bowlby One',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    letterSpacing: 'widest',
  },
  boxWrapper: {
    px: 0,
    mt: '-2',
  },
  accordionButton: {
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopRadius: 'md',
      border: 'none',
      fontSize: 'sm',
    },
  },
  accordionPanelBoxInner: {
    mb: '3',
  },
  accordionPanelBoxInnerLink: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
    sx: { _hover: { textDecoration: 'none' } },
  },
  marketGroupsByLetterHeadingText: {
    sx: {
      fontFamily: 'accent',
      color: 'white',
      fontsize: 'md',
      my: '2',
      fontWeight: 'bold',
    },
  },
  topLeaguesAccordionItem: {
    mt: '3',
    borderBottomRadius: 'base',
    p: '1px',
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset, 0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
    bg: 'rgba(0, 209, 255, 0.25)',
  },
  marketGroupsByLetterAccordionItem: {
    border: 'none',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset, 0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
    bg: 'rgba(0, 209, 255, 0.25)',
    borderRadius: 'md',
    mb: '2',
    sx: {
      _last: {
        button: {
          _last: {
            borderBottomRadius: 'md',
          },
        },
      },
      _first: {
        button: {
          _first: { borderTopRadius: 'md', border: 'none' },
        },
      },
    },
  },
  marketGroupsByLetterAccordionButton: {
    color: 'white',
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderRadius: 'unset',
    },
  },
  marketGroupsByLetterTitleText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    fontFamily: 'accent',
    sx: {
      img: {
        borderRadius: 'base',
        filter: 'drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.25))',
      },
    },
  },
  marketGroupsByLetterCountryFlag: {
    marginRight: '10px',
    height: '20px',
    width: '28px',
  },
  marketGroupsByLetterAccordionPanel: {
    px: '3',
    pt: '0',
    pb: '3',
  },
  marketGroupsByLetterAccordionIcon: {
    color: 'beta.300',
  },
  marketGroupsByLetterAccordionPanelBox: {
    borderLeftWidth: '3px',
    borderColor: 'beta.300',
    px: '2',
  },
  marketGroupsByLetterAccordionPanelLink: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'semibold',
    fontFamily: 'accent',
    sx: { _hover: { textDecoration: 'none' } },
  },
  accordionIcon: { color: 'beta.300' },
  accordionPanel: {
    px: '3',
    py: '0',
  },
  accordionPanelBoxWrapper: {
    borderLeftWidth: '3px',
    borderColor: 'beta.300',
    px: '3',
  },
  topLeaguesText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'bold',
    fontFamily: 'accent',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    px: 0,
  },
  navWrapper: {
    pb: '0',
  },
};
